import React from 'react';
import './FooterRoutes.css';

const RefundPolicy = () => {
  return (
    <div className="container">
      <h1 className="title">Refund Policy</h1>
      <p>Thank you for choosing us. We understand that circumstances may arise where you may need to request a refund. This Refund Policy outlines our procedures for handling refund requests to ensure transparency and fairness in our interactions with customers.</p>

      <div className="section">
        <h2 className="subtitle">1. Eligibility for Refund</h2>
        <ul>
          <li>Manufacturing Defects: If the eyewear received is defective or damaged due to manufacturing issues.</li>
          <li>Prescription Issues: In the case of incorrect prescription lenses, we will review and address the situation accordingly.</li>
          <li>Non-Delivery: If the order is not delivered within a reasonable time frame or is deemed undeliverable.</li>
        </ul>
      </div>

      <div className="section">
        <h2 className="subtitle">2. Refund Process</h2>
        <ul>
          <li>To request a refund, please contact our customer support team at <a href="mailto:support@spectsgenie.com">support@spectsgenie.com</a> within 14 days of receiving your order.</li>
          <li>Provide order details, a clear description of the issue, and any relevant supporting documentation, such as images of the defective product.</li>
          <li>Our customer support team will review your request and respond within 7 business days.</li>
        </ul>
      </div>

      <div className="section">
        <h2 className="subtitle">3. Refund Options</h2>
        <ul>
          <li>Full Refund: If the product is deemed defective or the error is on our end.</li>
          <li>Partial Refund: In cases where only a portion of the order is affected.</li>
          <li>Replacement: We may offer to replace the defective product with a new one.</li>
        </ul>
      </div>

      <div className="section">
        <h2 className="subtitle">4. Return of Products</h2>
        <p>If a return is required, we will provide instructions on how to return the product. Returned items must be in their original condition, including packaging, accessories, and any accompanying documentation within 14 days of delivery.</p>
      </div>

      <div className="section">
        <h2 className="subtitle">5. Refund Timeframe</h2>
        <p>Refunds will be processed within 7 business days of the approval of your request. The actual time it takes for the refund to reflect in your account may vary depending on your payment method and financial institution.</p>
      </div>

      <div className="section">
        <h2 className="subtitle">6. Non-Refundable Items</h2>
        <p>Certain items, such as customized or prescription eyewear in good working condition, may be non-refundable due to their personalized nature. Please check the product description for details.</p>
      </div>

      <div className="section">
        <h2 className="subtitle">7. Contact Us</h2>
        <p>If you have any questions or concerns about our Refund Policy, please contact us at <a href="mailto:support@spectsgenie.com">support@spectsgenie.com</a>.</p>
      </div>

      <p><strong>Note:</strong></p>
      <ul>
        <li>This Refund Policy is subject to change without notice. Please review this policy periodically for any updates.</li>
        <li>By making a purchase with us, you agree to the terms and conditions outlined in this Refund Policy.</li>
      </ul>

      <p>Thank you for choosing us. We appreciate your trust and are committed to providing you with a positive shopping experience.</p>
    </div>
  );
};

export default RefundPolicy;
